import { useMutation } from "@tanstack/react-query";
import { CreateOrganizerParams, createOrganizer } from "supabase/organizers";
import { queryClient } from "utils";

export const useCreateOrganizer = (
  onSuccess: (created: { id: number; name: string }) => any
) => {
  const mutation = useMutation({
    mutationFn: (organizer: CreateOrganizerParams) => {
      return createOrganizer(organizer);
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["organizers"],
      });

      if (data && data.id && data.name) {
        onSuccess({ id: data.id, name: data.name });
      } else {
        onSuccess(data);
      }
    },
  });

  return mutation;
};
